import ImgTag from '../ImgTag'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { Tag } from '../Tag'

interface IProductItemTagProps {
  item: IItemProductItemTag
}

export interface IItemProductItemTag {
  url?: string
  name: string
  quantity?: number
  isCollection?: boolean
  commissionName?: string
}

const ProductItemTag = (props: IProductItemTagProps) => {
  const { item } = props
  const { isCollection } = item
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        mb: 1,
        backgroundColor: '#e1f5fa',
        padding: '5px',
        borderRadius: 1,
      }}
    >
      <ImgTag imageUrl={item.url} name={item.name} size={30} />
      <Box>
        <Typography
          variant="subtitle2"
          fontSize={12}
          color="info.main"
          sx={{ marginLeft: 1 }}
          textAlign={'left'}
        >
          {item.name} {item.quantity && `x ${item.quantity}`}{' '}
          {isCollection && <>(เซ็ต)</>}
          {item.commissionName !== '' && (
            <Tag color="warning" style={{ fontSize: 10 }}>
              {item.commissionName}
            </Tag>
          )}
        </Typography>
      </Box>
    </Box>
  )
}

export default ProductItemTag
